import { Type } from '@angular/core';
import { NgModule, ModuleWithProviders } from '@angular/core';

import { CommonModule } from '@angular/common';

import { QuiverCommonModule } from '../common/common.module';

import { TdNotificationCountComponent, TdNotificationCountPositionX, TdNotificationCountPositionY } from './notification-count.component';

const /** @type {?} */ TD_NOTIFICATIONS: Type<any>[] = [
  TdNotificationCountComponent,
];

export { TdNotificationCountComponent, TdNotificationCountPositionX, TdNotificationCountPositionY } from './notification-count.component';
export class QuiverNotificationsModule {

static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
  ],
  declarations: [
    TD_NOTIFICATIONS,
  ],
  exports: [
    TD_NOTIFICATIONS,
  ],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function QuiverNotificationsModule_tsickle_Closure_declarations() {
/** @type {?} */
QuiverNotificationsModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
QuiverNotificationsModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
